export default [
    {
      path: '/admin/restaurant-order-kdu',
      name: 'view-order-kdu',
      meta: { requiresAuth: true },
      component: () => import('@/pages/restaurant-order/kdu')
    }
  ]
  